module.exports = __webpack_public_path__ + "static/media/Dif2_AcercaDe_1024.b0d0f4ca.png";